import React, { useEffect, useRef } from 'react';
import { useOverlayScrollbars } from 'overlayscrollbars-react';
import 'overlayscrollbars/styles/overlayscrollbars.css';

export const FullHeightOverlayScrollbars: React.FC<{
  children: React.ReactNode | React.ReactElement;
  height: string | number;
}> = props => {
  const ref = useRef<HTMLDivElement>(null);
  const [initialize, instance] = useOverlayScrollbars({
    options: {
      overflow: {
        x: 'hidden',
        y: 'scroll'
      },
      scrollbars: {
        autoHide: 'scroll',
        theme: 'os-theme-dark'
      }
    },
    events: {
      scroll: () => {
        // OverlayScrollbars scroll event
      }
    },
    defer: true
  });

  useEffect(() => {
    if (ref.current) {
      initialize(ref.current);
    }
  }, [initialize]);

  return (
    <div
      ref={ref}
      style={{
        height: props.height,
        width: '100%'
      }}
    >
      <div style={{ padding: '0px', minHeight: '100%' }}>
        {props.children}
      </div>
    </div>
  );
};
